import {
  Component,
  OnInit,
  Input,
  HostBinding,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import { LoadingState } from '@shared/types/loading-state';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false,
})
export class LoaderComponent implements OnInit {
  private _loadingState: LoadingState;
  private _debounceTimer: ReturnType<typeof setTimeout> | null = null;
  private _leaveTimer: ReturnType<typeof setTimeout> | null = null;
  showLoader = false;
  spinnerAnimClass = '';

  @Input() set loadingState(value: LoadingState) {
    this._loadingState = value;
    if (value === 'loading') {
      if (this._leaveTimer !== null) {
        clearTimeout(this._leaveTimer);
        this._leaveTimer = null;
      }
      if (this._debounceTimer === null) {
        this._debounceTimer = setTimeout(() => {
          this._debounceTimer = null;
          this.showLoader = true;
          this.spinnerAnimClass = 'spinner-enter';
          this.cdr.markForCheck();
        }, 25);
      }
    } else {
      if (this._debounceTimer !== null) {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = null;
      }
      if (this.showLoader) {
        this.spinnerAnimClass = 'spinner-leave';
        this.cdr.markForCheck();
        this._leaveTimer = setTimeout(() => {
          this._leaveTimer = null;
          this.showLoader = false;
          this.cdr.markForCheck();
          // Clear anim class after overlay fade-out (150ms) so forwards fill holds during the fade
          setTimeout(() => {
            this.spinnerAnimClass = '';
            this.cdr.markForCheck();
          }, 150);
        }, 200);
      }
    }
  }
  get loadingState(): LoadingState {
    return this._loadingState;
  }
  @Input() size: number;
  @Input() inline = false;
  @Input() top: number = 0;
  @Input() screenWidth: boolean = false;
  @Input() relativeWidthAndHeight: boolean = false;
  @Input() color = 'primary';
  @Input() helperText: string = '';
  loaderHeight: number;
  loaderWidth: string;

  @HostBinding('style.display') display: string;
  @HostBinding('style.position') position = 'fixed';
  @HostBinding('class.inline') inlineClass = this.inline;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.display = this.inline ? 'inline-block' : 'contents';
    this.position = this.inline ? 'absolute' : 'fixed';
    this.loaderHeight = window.innerHeight - this.top;
    this.loaderWidth = this.screenWidth ? '100%' : '';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.loaderHeight = event.target.innerHeight - this.top;
  }
}
